<template>
  <div class="app-container">
    <h4 class="form-header h4">{{ $t('app.system.authRole.basicInfo') }}</h4>
    <el-form ref="form" :model="form" label-width="80px">
      <el-row>
        <el-col :span="8" :offset="2">
          <el-form-item :label="$t('app.system.authRole.userNickname')" prop="realName">
            <el-input v-model="form.realName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="2">
          <el-form-item :label="$t('app.system.authRole.loginAccount')" prop="username">
            <el-input  v-model="form.username" disabled />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <h4 class="form-header h4">{{ $t('app.system.authRole.roleInfo') }}</h4>
    <el-table v-loading="loading" :row-key="getRowKey" @row-click="clickRow" ref="table" @selection-change="handleSelectionChange" :data="roles.slice((pageNum-1)*pageSize,pageNum*pageSize)">
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column :label="$t('app.system.authRole.roleId')" align="center" prop="id" />
      <el-table-column :label="$t('app.system.authRole.roleName')" align="center" prop="name" />
      <el-table-column :label="$t('app.system.authRole.permissionKey')" align="center" prop="roleKey" />
      <el-table-column :label="$t('app.system.authRole.createTime')" align="center" prop="createTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination 
    v-show="total>0" 
    :total="total" 
    :page.sync="pageNum" 
    :limit.sync="pageSize" 
    />
    <el-form label-width="100px">
      <el-form-item style="text-align: center;margin-left:-120px;margin-top:30px;">
        <el-button type="primary" @click="submitForm()">{{ $t('app.common.submit') }}</el-button>
        <el-button @click="close()">{{ $t('app.common.back') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { authRole, updateAuthRole } from "@/api/api";

export default {
  name: "AuthRole",
  data() {
    return {
       // 遮罩层
      loading: true,
      // 分页信息
      total: 0,
      pageNum: 1,
      pageSize: 10,
      // 选中角色编号
      roleIds:[],
      // 角色信息
      roles: [],
      // 用户信息
      form: {}
    };
  },
  created() {
    const userId = this.$route.params && this.$route.params.userId;
    if (userId) {
      this.loading = true;
      authRole({userId : userId}).then((res) => {
        this.form = res.data.data.user;
        this.roles = res.data.data.roles;
        this.total = this.roles.length;
        this.$nextTick(() => {
          this.roles.forEach((row) => {
            if (row.flag) {
              this.$refs.table.toggleRowSelection(row);
            }
          });
        });
        this.loading = false;
      });
    }
  },
  methods: {
    /** 单击选中行数据 */
    clickRow(row) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.roleIds = selection.map((item) => item.roleId);
    },
    // 保存选中的数据编号
    getRowKey(row) {
      return row.roleId;
    },
    /** 提交按钮 */
    submitForm() {
      const userId = this.form.userId;
      const roleIds = this.roleIds.join(",");
      updateAuthRole({ userId: userId, roleIds: roleIds }).then((response) => {
        this.$modal.msgSuccess("授权成功");
        this.close();
      });
    },
    /** 关闭按钮 */
    close() {
      const obj = { path: "/system/user" };
      this.$tab.closeOpenPage(obj);
    },
  },
};
</script>